import { requestV1 } from './base'
import { DoorTop, Doors, User, Keyword, Banner, Review } from './response_types'

export interface MeDoorResponse {
  door: MeDoor | null
  owner: User
  staff: string | null
  publish_status: {
    door: boolean
    owner: boolean
    personal: boolean
    plan: boolean
  }
  me: {
    permit_admin: boolean
  }
}
export interface IntroPromptInput {
  [key: string]: string
}
export interface IntroPromptInputLength {
  [key: string]: number
}

export interface MeDoor {
  title: string
  description: string
  door_recommends: string[]
  door_images: Array<{
    id: number
    description: string
    image_url: string
    order: number
    created_at: string
    updated_at: string
  }>
  door_owners: Array<{
    id: number
    description: string
    image_url: string
    order: number
    created_at: string
    updated_at: string
  }>
  keywords: Keyword[]
  external_video_link: string
  is_display_member_count: boolean
  status: 'in_private' | 'published'
  can_publish: boolean,
  plan_capacity: number
}

export const getMeDoorV1 = async (doorId?: string) => {
  let path = `/me/door`
  if (doorId !== undefined) path += `?door_id=${doorId}`
  return await requestV1<MeDoorResponse>('get', path)
}

export const updateMeDoorV1 = async (
  data: {
    title: string
    description: string
    door_recommends: string[]
    is_display_member_count: boolean
    door_images: {
      description: string
      image: string | null // 変更なし: '', 変更あり: 画像データ, 削除: null
      order: number
    }[]
    external_video_link: string
    keyword_ids: number[]
    door_id?: string
  },
  doorId?: string
) => {
  if (doorId !== undefined) data['door_id'] = doorId
  return await requestV1<MeDoorResponse>('patch', `/me/door`, data)
}

export const deleteMeDoorV1 = async (doorId?: string) => {
  const data = doorId !== undefined ? { door_id: doorId } : {}
  return await requestV1<void>('delete', '/me/door', data)
}

export const publishMeDoorV1 = async (doorId?: string) => {
  const data = doorId !== undefined ? { door_id: doorId } : {}
  return await requestV1<MeDoorResponse>('post', '/me/door/publish', data)
}

export const getDoor = async (doorID: string, secret?: string) => {
  let path = `/doors/${doorID}`
  if (secret) path = path + `?secret=${secret}`
  return await requestV1<DoorTop>('get', path)
}

export const getCarouselSalonBanner = async () => {
  return await requestV1<{ carousel_banners?: Banner[] }>(
    'get',
    '/carousel_salon_banner'
  )
}

export const getRecommendDoors = async (page: number = 1, per?: number) => {
  return await requestV1<Doors>(
    'get',
    `/doors?page=${page}&per=${per}&category=recommend`
  )
}
export const getPickupDoors = async (page: number = 1, per?: number) => {
  return await requestV1<Doors>(
    'get',
    `/doors?page=${page}&per=${per}&category=pickup`
  )
}

export const getReviews = async (doorID: string, page: number, per: number) => {
  return await requestV1<{reviews: Review[]}>('get', `/doors/${doorID}/reviews?page=${page}&per=${per}`)
}
export const createReview = async (doorID: string, body: string) => {
  const data = { body: body }
  return await requestV1<null>('post', `/doors/${doorID}/reviews`, data)
}
export const getReviewRequestByDoor = async (doorID: string) => {
  return await requestV1<null>('get', `/me/doors/${doorID}/review_request`)
}
// ドアキーワード検索
export const getSearchDoors = async (
  keyword: string,
  page: number = 1,
  per?: number
) => {
  return await requestV1<Doors>(
    'get',
    `/searches?keyword=${keyword}&page=${page}&per=${per}&category=pickup`
  )
}

export const getFreeDoors = async (page: number = 1, per?: number) => {
  return await requestV1<Doors>(
    'get',
    `/doors?page=${page}&per=${per}&category=free`
  )
}

export const getUrgent = async (target: string) => {
  return await requestV1<any>('get', `/urgent?target=${target}`)
}

export type creditCardAlert = 'expired' | 'expiring' | 'failure'

export const getCreditcardAlert = async () => {
  return await requestV1<{ creditcard_alert: creditCardAlert } | null>(
    'get',
    '/creditcard_alert'
  )
}

export const getIntroPromptInputV1 = async (door_id?: string) => {
  let path = '/me/intro_prompt_inputs/saved_answer'
  if (door_id !== undefined) path += `?door_id=${door_id}`
  return await requestV1<IntroPromptInput | null>('get', path)
}

export const deleteIntroPromptInputV1 = async (door_id?: string) => {
  let path = '/me/intro_prompt_inputs/delete_answer'
  if (door_id !== undefined) path += `?door_id=${door_id}`
  return await requestV1<any>('delete', path)
}

export const saveIntroPromptInputV1 = async (
  data: IntroPromptInput,
  door_id?: string
) => {
  if (door_id !== undefined) data['door_id'] = door_id
  return await requestV1<null>('post', '/me/intro_prompt_inputs', data)
}

export const createSuggestionV1 = async (
  data: IntroPromptInput,
  door_id?: string
) => {
  if (door_id !== undefined) data['door_id'] = door_id
  return await requestV1<any>('post', '/me/intro_suggestions', data)
}

export const getSuggestionV1 = async (id: number) => {
  return await requestV1<any>('get', `/me/intro_suggestions/${id}`)
}

export const getSuggestionSuggestedV1 = async (door_id?: string) => {
  let path = '/me/intro_suggestions/suggested'
  if (door_id !== undefined) path += `?door_id=${door_id}`
  return await requestV1<any>('get', path)
}

export const abortSuggestionV1 = async (intro_suggestion_id: number) => {
  return await requestV1<null>(
    'patch',
    `/me/intro_suggestions/${intro_suggestion_id}/abort`
  )
}
